import {ref, watch} from "vue";

// Tweens a displayed number toward a reactive source so rewards (score, XP) tick up
// instead of snapping. Pass a getter, e.g. useCountUp(() => props.xp).
// easeOutCubic gives a fast-then-settle feel that matches the XP bar's width transition.
export function useCountUp(getValue, {duration = 700} = {}) {
    const display = ref(getValue() ?? 0);
    let frame = 0;

    watch(getValue, (to, from) => {
        const start = performance.now();
        const startValue = Number(from) || 0;
        const target = Number(to) || 0;
        // No movement worth animating (e.g. initial hydrate or unchanged value): just set it.
        if (startValue === target) {
            display.value = target;
            return;
        }
        cancelAnimationFrame(frame);
        const step = (now) => {
            const t = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - t, 3);
            display.value = Math.round(startValue + (target - startValue) * eased);
            if (t < 1) frame = requestAnimationFrame(step);
        };
        frame = requestAnimationFrame(step);
    });

    return display;
}
